import {consoleLog} from './log';
import relationshipService from '../services/relationship/RelationshipService';
import enrollmentService from '../services/enrollment';
import projectService from '../services/project/ProjectService';

export function cancelInvitation({relationshipId, invitationId}) {
  if (relationshipId) {
    consoleLog(`Cancelling the internal invitation ${relationshipId}`);
    return relationshipService.cancelPendingRelationship(relationshipId);
  }

  consoleLog(`Cancelling the external invitation ${invitationId}`);
  return enrollmentService.network.cancelPendingInvitation(invitationId);
}

export function cancelInterventionInvitation({interventionId, invitationId}) {
  if (interventionId) {
    consoleLog(`Cancelling the project internal intervention ${interventionId}`);
    return projectService.cancelPendingIntervention(interventionId);
  }

  consoleLog(`Cancelling the project external invitation ${invitationId}`);
  return enrollmentService.project.cancelPendingInvitation(invitationId);
}
